<template>
  <div
    class="w-100 p-3 banner-container d-flex position-relative"
    @click="callToAction"
  >
    <div>
      <div style="max-width: 79%">
        <h3>
          {{ t("CREDIT_LIMIT_PROMO.TITLE", { newLimit: limitIncreaseAmount }) }}
        </h3>
      </div>
      <p class="p-0 m-0">
        {{ t("CREDIT_LIMIT_PROMO.CTA", { expiryDate }) }}
      </p>
    </div>
    <img
      class="float-end position-absolute end-0 bottom-0"
      :src="useAsset('img/credit-line/jumping_coins.svg')"
      alt="jumping coins"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import useAsset from "@/apps/credit-line/helpers/useAsset";

defineProps({
  limitIncreaseAmount: {
    type: String,
    required: true,
  },
  expiryDate: {
    type: String,
    required: true,
  },
});

const { t } = useI18n();

const emit = defineEmits(["ctaClicked"]);

const callToAction = (): void => {
  emit("ctaClicked");
};
</script>

<style lang="scss" scoped>
.banner-container {
  min-height: 76px;
  max-height: 89px;
  border-radius: 5px;
  background: #f2f2f2;
}

h3 {
  color: var(--Typography-Text-2-ICON, #595a5a);
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter, serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 17px; /* 121.429% */
}

p {
  color: var(--Primary-Main-green, #007c3b);
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter, serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 21px; /* 150% */
}
</style>
